import React from "react";
import {useSelector} from "react-redux";

import {ContextNodeAutoSelect} from "./ContextNodeAutoSelect";

export const UserOrgContextNodeAutoSelect = props => {
    const organizationId = useSelector(state => state.userState.user.organizationId);

    return <ContextNodeAutoSelect
        Value={props?.Value}
        userRoleId={props?.UserRoleId || null}
        placeholder={props?.placeholder}
        allowNull={props?.allowNull}
        OnUpdate={props?.OnUpdate}
        OrganizationId={organizationId}
    />
};


